var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMasterW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 680.31 680.31",
    style: {
      enableBackground: "new 0 0 680.31 680.31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#C6C6C6;}\r\n\t.st2{fill:#EDEDED;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M559.13,305.35V629.7h-126.6v-59.08c0-22.26,5.6-44.16,16.28-63.68L559.13,305.35z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "287.52,513.45 224.15,629.71 142.35,479.28 142.35,246.52  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.52,513.45l-63.37,116.26l-81.8-150.43L31.71,275.88c13.84-17.86,35.56-29.36,59.92-29.36h50.72 L287.52,513.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.35,246.52v383.19H15.74v-307.3c0-17.54,5.95-33.67,15.98-46.53c13.84-17.86,35.56-29.36,59.92-29.36 H142.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.32,224.43L589.08,58.81c-3.13-6.99-11.34-10.11-18.33-6.98l-165.63,74.24 c-11.27,5.05-10.81,21.21,0.74,25.61l43.58,16.6c11.5,4.38,16.49,17.9,10.6,28.7L224.14,629.69h56.29 c43.35,0,83.26-23.65,104.07-61.68L568.22,232.3c4.87-8.9,15.57-12.84,25.05-9.23l52.47,19.99 C657.28,247.46,668.38,235.7,663.32,224.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M523.57,313.9L384.5,568c-20.81,38.03-60.7,61.7-104.09,61.7h-56.29L460.05,197 c4.13-7.54,2.95-16.4-2.04-22.58C480.77,191.96,539.97,245.11,523.57,313.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMasterW);
export default __webpack_public_path__ + "static/media/logo-master-w.fd0daba847b519de50dde78d1d9d0972.svg";
export { ForwardRef as ReactComponent };